// extracted by css-extract-rspack-plugin
export default {"parametersLabel":"parametersLabel-LH3O3o"};